import { render, staticRenderFns } from "./CreateResourceForm.vue?vue&type=template&id=58a5656e&scoped=true&"
import script from "./CreateResourceForm.vue?vue&type=script&lang=js&"
export * from "./CreateResourceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a5656e",
  null
  
)

export default component.exports